import { Component, OnInit } from '@angular/core'
import { MessageService } from '@services/message/message.service'
import { DestroyerComponent} from '@components/app-core/components/destroyer/destroyer.component'
import { filter, takeUntil } from 'rxjs/operators'
import { IMessage } from '@interfaces/i-message'
import { StorageService } from '@services/storage/storage.service'
import { csfStorageKeys } from '@components/exportable/css-filters-control/data/csf-storage-keys'
import { CssFiltersComponent } from '@components/exportable/css-filters-control/css-filters/css-filters.component'

@Component({
  selector: 'app-css-filters-control',
  templateUrl: './css-filters-control.component.html',
  styleUrls: ['./css-filters-control.component.scss'],
  standalone: true,
  imports: [CssFiltersComponent],
})
export class CssFiltersControlComponent extends DestroyerComponent implements OnInit {
  show = this.storageService.getItem(csfStorageKeys.switch, false, 'messageReplay')

  constructor(private messageService: MessageService, private storageService: StorageService) {
    super()
  }

  ngOnInit(): void {
    this.messageService.messageReplay$
      .pipe(
        takeUntil(this.unsubscribe$),
        filter((message: IMessage) => message.name === csfStorageKeys.switch),
      )
      .subscribe((message: IMessage) => {
        this.show = message.payload
      })
  }
}
